var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('img',{attrs:{"src":"img/footer.png","alt":"푸터"}}),_vm._v(" "),_c('div',{attrs:{"id":"top"},on:{"click":_vm.scrollToTop}},[_c('img',{attrs:{"src":"img/btn_top.png","alt":"탑버튼"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c2cd62e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 49
// module chunks = 0